import { render, staticRenderFns } from "./Revise.vue?vue&type=template&id=e961885e&scoped=true&"
import script from "./Revise.vue?vue&type=script&lang=js&"
export * from "./Revise.vue?vue&type=script&lang=js&"
import style0 from "./Revise.vue?vue&type=style&index=0&id=e961885e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e961885e",
  null
  
)

export default component.exports